import { SortOption } from '@/types';
import { router } from '@inertiajs/react';
import { ParsedQs } from 'qs';
import { route } from 'ziggy-js';
import { create } from 'zustand';

export interface QueryFilter {
    sort: SortOption;
    qp: ParsedQs;
    initializeQueryFilter: () => void;
    handleSort: (newSort: SortOption) => void;
}

export const useQueryFilterStore = create<QueryFilter>((set, get) => ({
    sort: '-created_at',
    qp: {},

    // Инициализация корзины данными с сервера
    initializeQueryFilter: () => {
        const qp = route().queryParams;

        const { sort } = (qp ?? {}) as { sort?: SortOption };

        set({
            qp: qp ?? {},
            sort: typeof sort === 'string' ? sort : 'created_at',
        });
    },

    handleSort: (newSort: SortOption) => {
        router.get(
            route('home'),
            { ...get().qp, sort: newSort },
            {
                only: ['products'],
                reset: ['products'],
            },
        );
    },
}));

export const useQueryFilter = () => {
    const store = useQueryFilterStore();
    return {
        sort: store.sort,
        initializeQueryFilter: store.initializeQueryFilter,
        handleSort: store.handleSort,
    };
};

export default useQueryFilterStore;
